"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DEFAULT_EUI_SUBSTRING = void 0;
exports.DEFAULT_EUI_SUBSTRING = '70B3D516B000';
